import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import BlockingInput from '../components/BlockingInput';
import FieldContainer from '../components/FieldContainer';
import { ensureConstraint, isAllConstraintsValid, validateConstraints } from '../utils/passwordUtils';

const { status: userStatus } = window.__DATA__?.data || {};

const ValidationMark = ({ valid }) => {
  if (!valid)
    return (
      <span className="af-password-constraint__mark af-password-constraint__mark--invalid" style={{ color: 'red', width: 20 }}>
        &#10008;
      </span>
    );
  return (
    <span className="af-password-constraint__mark af-password-constraint__mark--valid" style={{ color: 'green', width: 20 }}>
      &#10004;
    </span>
  );
};

class PasswordField extends PureComponent {
  static defaultProps = {
    // inputType: "text",
    value: '',
    required: false,
  };

  state = {
    confirm: '',
  };

  getStrings() {
    const { t } = this.props;
    return { passwordConfirm: t('password.confirm'), notSameError: t('password.not-same'), ...this.props.strings };
  }

  isValid = (validatedConstraints) => {
    const { value, passwordType } = this.props;
    switch (passwordType) {
      case 'complex': {
        return isAllConstraintsValid(validatedConstraints);
      }
      case 'simple':
      default: {
        const { confirm } = this.state;
        return (confirm || '') === (value || '');
      }
    }
  };

  getValidatedConstraints = () => {
    const { value, passwordType } = this.props;
    const { confirm } = this.state;
    const constraints = ensureConstraint(passwordType);
    return validateConstraints(value, confirm, constraints);
  };

  render() {
    const { id, mode, name, summary, value, data, disabled, placeholder, label, onChange, passwordType = 'simple' } = this.props;
    const { confirm } = this.state;
    const { t } = this.props;
    if (disabled && !value) return null; // Hide disabled field
    const validatedConstraints = this.getValidatedConstraints();
    const { passwordConfirm, notSameError } = this.getStrings();
    // Never required on update :-)
    const required = this.props.required && userStatus !== 'registered';
    if (mode === 'summary') {
      if (summary?.hidden) {
        return null;
      }
      return (
        <FieldContainer {...this.props} required={false} label={summary?.label || label}>
          <div className="af-string-field-summary">
            <span className="value">{t('password.summary')}</span>
          </div>
        </FieldContainer>
      );
    }
    return (
      <React.Fragment>
        <FieldContainer {...this.props} required={required}>
          <input
            id={id}
            className="af-password-field"
            name={name}
            type="password"
            placeholder={placeholder || label}
            value={value || ''}
            required={required}
            onChange={(e) => onChange(name, e.target.value)}
          />
        </FieldContainer>
        <FieldContainer {...this.props} label=" " required={false}>
          <input
            id={id + 'Confirm'}
            className="af-password-field"
            name={name + 'Confirm'}
            type="password"
            placeholder={passwordConfirm}
            value={confirm}
            required={required}
            onChange={(e) => this.setState({ confirm: e.target.value })}
          />
          {!this.isValid() && passwordType === 'simple' && <div className="af-message af-message--error">{notSameError}</div>}

          {passwordType === 'complex' && (
            <div className="af-password-constraints" style={{ marginBottom: 20, textAlign: 'justify' }}>
              {validatedConstraints.map(({ isValid, min, type }) => (
                <div key={type} className="af-password-constraint" style={{ display: 'flex' }}>
                  <ValidationMark valid={isValid} />
                  {t(type, { min })}
                </div>
              ))}
            </div>
          )}
          {!this.isValid(validatedConstraints) && <BlockingInput name={name} />}
        </FieldContainer>
      </React.Fragment>
    );
  }
}

export default withTranslation()(PasswordField);
